import * as Formats from './MediaFormats';

export const getMediaHandler = async ({ Media, External_VAST }) => {
  if(!Media || Media.length === 0) {
    throw new Error('valid media not provided');
  }

  const setting    = Media[0], // we only support a single media file at the moment, use the first one
        getHandler = handlerMapping[setting.format];

  if(getHandler) {
    return getHandler().then( handler => {
      return new handler.default(setting, External_VAST.AdParameters);
    });
  } else {
    throw new Error(`no media handler available for format "${setting.format}"`);
  }
};

export const handlerMapping = {};
handlerMapping[Formats.VPAID] = () => import('Media/Handlers/VPAIDHandler');
handlerMapping[Formats.FILE]  = () => import('Media/Handlers/FileHandler');


// WEBPACK FOOTER //
// ./src/Media/MediaFactory.js